import React from 'react';
import DsButton from '../../common/DsButton';
import DsModal from '../../common/DsModal';
import EventListSkeleton from '../../common/events/EventListSkeleton';
import { SkeletonLine, SkeletonPill } from '../../common/Skeleton';

export default function EventDetailsGroupParticipants({ view }) {
  const {
    CHAT_GROUP_EXECUTE_MODE,
    CHAT_GROUP_MODE,
    CHAT_GROUP_MODE_LABEL,
    canEditChatGroupSetting,
    canUseEventChat,
    chatGroupConfirmState,
    chatGroupCurrentMode,
    chatGroupDraftChanged,
    chatGroupDraftMode,
    chatGroupPreviewLoading,
    chatGroupSaving,
    chatGroupSettingLoading,
    chatGroupUpdatedAtLabel,
    closeChatGroupConfirmModal,
    eventReadOnlyTitle,
    groupEventRows,
    groupEventsLoading,
    groupRootPerformanceLabel,
    isCurrentEventGroupRoot,
    openChatGroupConfirmModal,
    renderGroupEventRow,
    setChatGroupDraftMode,
    shouldShowGroupEventsPanel,
    submitChatGroupModeChange,
  } = view;

  return (
    <>
          {/* 全体進捗はヘッダー右のアサイド（案B）へ移設済み（eventDetailsPrimarySections） */}
          {shouldShowGroupEventsPanel ? (
            <section className="event-panel group-events-panel" id="event-group-section">
              <div className="panel-heading group-events-panel__heading">
                <div>
                  <h3>グループイベント</h3>
                  <p className="group-events-panel__meta">
                    親公演: {groupRootPerformanceLabel} / イベント数: {groupEventRows.length}件 / チャット: {CHAT_GROUP_MODE_LABEL[chatGroupCurrentMode] || '分離'}
                  </p>
                </div>
              </div>
              {canUseEventChat ? (
                <div className="group-events-panel__chat-setting">
                  <div className="group-events-panel__chat-setting-head">
                    <p className="group-events-panel__chat-setting-title">チャット設定</p>
                    <span
                      className={`group-events-panel__chat-setting-badge${
                        chatGroupCurrentMode === CHAT_GROUP_MODE.GROUP_UNIFIED ? ' is-unified' : ''
                      }`}
                    >
                      {CHAT_GROUP_MODE_LABEL[chatGroupCurrentMode] || '分離'}
                    </span>
                  </div>
                  {chatGroupUpdatedAtLabel ? (
                    <p className="group-events-panel__chat-setting-meta">
                      最終更新: {chatGroupUpdatedAtLabel}
                    </p>
                  ) : null}
                  {chatGroupSettingLoading ? (
                    <div className="group-events-panel__chat-setting-loading">
                      <SkeletonLine width={132} height={12} />
                      <SkeletonPill width={56} height={20} />
                    </div>
                  ) : null}

                  {isCurrentEventGroupRoot ? (
                    <div className="group-events-panel__chat-setting-controls">
                      <div className="segmented group-events-panel__chat-mode-toggle" role="group" aria-label="グループチャットモード">
                        <button
                          type="button"
                          className={`segmented__item${
                            chatGroupDraftMode === CHAT_GROUP_MODE.SEPARATE ? ' is-active' : ''
                          }`}
                          onClick={() => setChatGroupDraftMode(CHAT_GROUP_MODE.SEPARATE)}
                          disabled={!canEditChatGroupSetting || chatGroupPreviewLoading || chatGroupSaving}
                          title={!canEditChatGroupSetting ? eventReadOnlyTitle : undefined}
                        >
                          分離
                        </button>
                        <button
                          type="button"
                          className={`segmented__item${
                            chatGroupDraftMode === CHAT_GROUP_MODE.GROUP_UNIFIED ? ' is-active' : ''
                          }`}
                          onClick={() => setChatGroupDraftMode(CHAT_GROUP_MODE.GROUP_UNIFIED)}
                          disabled={!canEditChatGroupSetting || chatGroupPreviewLoading || chatGroupSaving}
                          title={!canEditChatGroupSetting ? eventReadOnlyTitle : undefined}
                        >
                          統合
                        </button>
                      </div>
                      <DsButton
                        className="group-events-panel__chat-apply-action"
                        onClick={openChatGroupConfirmModal}
                        disabled={
                          !canEditChatGroupSetting ||
                          !chatGroupDraftChanged ||
                          chatGroupPreviewLoading ||
                          chatGroupSaving
                        }
                        loading={chatGroupPreviewLoading}
                        title={!canEditChatGroupSetting ? eventReadOnlyTitle : undefined}
                      >
                        変更内容を確認
                      </DsButton>
                    </div>
                  ) : (
                    <p className="group-events-panel__chat-setting-note">
                      チャット設定の変更は親イベント側で行えます。
                    </p>
                  )}
                </div>
              ) : null}
              <div className="event-list-container group-events-list-container">
                {groupEventsLoading ? (
                  <EventListSkeleton viewMode="list" count={3} showListControl={false} />
                ) : (
                  <div className="event-list-rows">
                    {groupEventRows.map((event) => renderGroupEventRow(event))}
                  </div>
                )}
              </div>
            </section>
          ) : null}

          <DsModal
            open={chatGroupConfirmState.open}
            onClose={closeChatGroupConfirmModal}
            title={
              chatGroupConfirmState.executeMode === CHAT_GROUP_EXECUTE_MODE.MERGE
                ? 'グループチャットを統合しますか？'
                : 'グループチャットを分離しますか？'
            }
            size="md"
            className="group-chat-setting-modal"
            dismissible={!chatGroupSaving}
            footer={(
              <div className="group-chat-setting-modal__actions">
                <DsButton
                  variant="secondary"
                  onClick={closeChatGroupConfirmModal}
                  disabled={chatGroupSaving}
                >
                  キャンセル
                </DsButton>
                <DsButton
                  onClick={submitChatGroupModeChange}
                  disabled={chatGroupSaving}
                  loading={chatGroupSaving}
                >
                  {chatGroupConfirmState.executeMode === CHAT_GROUP_EXECUTE_MODE.MERGE
                    ? 'チャット統合を実行'
                    : 'チャット分離を実行'}
                </DsButton>
              </div>
            )}
          >
                <p className="group-chat-setting-modal__desc">
                  この操作はグループイベント全体のチャット表示・既読計算・通知に影響します。内容を確認して実行してください。
                </p>
                <div className="group-chat-setting-modal__metrics">
                  <div className="group-chat-setting-modal__metric-item">
                    <span>対象イベント</span>
                    <strong>{Number(chatGroupConfirmState.preview?.event_count || 0)}件</strong>
                  </div>
                  <div className="group-chat-setting-modal__metric-item">
                    <span>対象メッセージ</span>
                    <strong>{Number(chatGroupConfirmState.preview?.message_count || 0).toLocaleString()}</strong>
                  </div>
                  <div className="group-chat-setting-modal__metric-item">
                    <span>通知対象（管理者）</span>
                    <strong>{Number(chatGroupConfirmState.preview?.participants?.admin_count || 0)}人</strong>
                  </div>
                  <div className="group-chat-setting-modal__metric-item">
                    <span>通知対象（アーティスト）</span>
                    <strong>{Number(chatGroupConfirmState.preview?.participants?.artist_count || 0)}人</strong>
                  </div>
                  <div className="group-chat-setting-modal__metric-item">
                    <span>未読対象（管理者）</span>
                    <strong>{Number(chatGroupConfirmState.preview?.unread_targets?.unread_admin_count || 0)}人</strong>
                  </div>
                  <div className="group-chat-setting-modal__metric-item">
                    <span>未読対象（アーティスト）</span>
                    <strong>{Number(chatGroupConfirmState.preview?.unread_targets?.unread_artist_count || 0)}人</strong>
                  </div>
                </div>
          </DsModal>
    </>
  );
}
